"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UserPermissionsContentHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, "This page allows Super Users to add new users or edit existing users' permissions."),
    react_1.default.createElement("p", null,
        "Click the ",
        react_1.default.createElement("strong", null, "three dots"),
        " to the right of an existing user's name to re-send their invite or remove them. Click ",
        react_1.default.createElement("strong", null, "View "),
        " to be taken to a page to update or edit their permission."),
    react_1.default.createElement("p", null,
        "Definitions for each user permission can be viewed\u00A0",
        react_1.default.createElement("a", { href: 'https://help.themlc.com/en/support/what-are-the-different-types-of-permissions' }, "here."))));
exports.default = UserPermissionsContentHeader;
